import request from '../http';

/** 模型清单与开关 */
export const getAiGenerateOptions = () =>
  request({ url: '/material/ai-generate/options', method: 'get' });

/** 提交批量衍生 */
export const createAiDeriveBatch = (data) =>
  request({ url: '/material/ai-generate/derive', method: 'post', data });

/** 批次列表 */
export const listAiGenerateBatches = (params) =>
  request({ url: '/material/ai-generate/batches', method: 'get', params });

/** 批次详情 */
export const getAiGenerateBatch = (id) =>
  request({ url: `/material/ai-generate/batches/${id}`, method: 'get' });

/** 模板列表（管理页） */
export const listAiPromptTemplates = (params) =>
  request({ url: '/material/ai-prompt-templates', method: 'get', params });

/** 模板下拉全量 */
export const listAllAiPromptTemplates = () =>
  request({ url: '/material/ai-prompt-templates/all', method: 'get' });

export const createAiPromptTemplate = (data) =>
  request({ url: '/material/ai-prompt-templates', method: 'post', data });

export const updateAiPromptTemplate = (id, data) =>
  request({ url: `/material/ai-prompt-templates/${id}`, method: 'put', data });

export const deleteAiPromptTemplate = (id) =>
  request({ url: `/material/ai-prompt-templates/${id}`, method: 'delete' });
